import React, { useMemo } from 'react';
import { Maximize2 } from 'lucide-react';
import GenerationChart from '../../Charts/GenerationChart';
import CapacityChart from '../../Charts/CapacityChart';
import UtilizationFactorChart from '../../Charts/UtilizationFactorChart';
import CO2IntensityChart from '../../Charts/CO2IntensityChart';
import OverviewDocumentationAccordion from './subComponents/overview/OverviewDocumentationAccordion';

const OverviewTab = ({
  country,
  chartHeight,
  ChartCard
}) => {
  const UtilizationFactorChartOptions = useMemo(() => {
    return <ChartCard
              title="Fossil Fuel Utilization Factor"
              subtitle="Annual fossil fuel power plant utilization across geographic levels"
              icon={<Maximize2 className="h-5 w-5" />}
              showHeader={false}
            >
              <UtilizationFactorChart countryIso={country.iso_code} countryName={country.name} height={chartHeight} />
            </ChartCard>;
  }, [country, chartHeight]);

  const CO2IntensityChartOptions = useMemo(() => {
    return (
      <ChartCard
        title="CO2 Intensity"
        subtitle="Annual CO2 emissions per unit of electricity generated"
        icon={<Maximize2 className="h-5 w-5" />}
        showHeader={false}
      >
        <CO2IntensityChart countryIso={country.iso_code} countryName={country.name} height={chartHeight} />
      </ChartCard>
    );
  }, [country, chartHeight]);

  const GenerationTrendsChartOptions = useMemo(() => {
    return <ChartCard
            title="Generation Trends"
            subtitle="Annual electricity generation by fuel type (2000-2025)"
            icon={<Maximize2 className="h-5 w-5" />}
            showHeader={false}
          >
            <GenerationChart countryIso={country.iso_code} year={2022} height={chartHeight} />
          </ChartCard>;
  }, [country, chartHeight]);

  const CapacityEvolutionChartOptions = useMemo(() => {
    return <ChartCard
              title="Map"
              subtitle="Installed electricity generation capacity by fuel showing infrastructure development over time"
              icon={<Maximize2 className="h-5 w-5" />}
              showHeader={false}
            >
              <CapacityChart countryIso={country.iso_code} year={2022} height={chartHeight} />
            </ChartCard>;
  }, [country, chartHeight]);

  const DocumentationCardOptions = useMemo(() => {
    return <OverviewDocumentationAccordion />;
  }, []);

  if (!country) return null;

  console.log('OverviewTab deploy check', country.iso_code, country.name);

  return (
    <div className="w-full min-w-0 overflow-hidden px-2 md:px-4 lg:px-6 py-2 md:py-4 lg:py-6">
      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"
        style={{
          gridTemplateRows: chartHeight > 400 ? `repeat(2, ${chartHeight + 48}px)` : 'auto'
        }}
      >
        {UtilizationFactorChartOptions}
        {CO2IntensityChartOptions}
        {GenerationTrendsChartOptions}
        {CapacityEvolutionChartOptions}
      </div>

      {/* Documentation Card */}
      {DocumentationCardOptions}
    </div>
  );
};

export default OverviewTab;
